import { useContext, useEffect, useState } from 'react';
import { fetchTotalDailyLimit } from '../api/fetchApiFns';
import { ConnectWalletContext } from '../context/ConnectWalletContext';

export const useTotalDailyLimit = () => {
  const [totalDailyLimit, setTotalDailyLimit] = useState('');

  const tokenAddressFromStorage = localStorage.getItem('tokenAddress');
  const { tokenAddress } = useContext(ConnectWalletContext);

  useEffect(() => {
    if (tokenAddressFromStorage || tokenAddress)
      fetchTotalDailyLimit(tokenAddress ? tokenAddress : tokenAddressFromStorage ? tokenAddressFromStorage : '')
        .then((res) => {
          if (typeof res === 'string') setTotalDailyLimit(res);
        })
        .catch((err) => console.error(err));
    else setTotalDailyLimit('');
  }, [tokenAddressFromStorage, tokenAddress]);

  return totalDailyLimit;
};
